import { getCookie } from '@ynap/redux-cookies-middleware/src/cookieApi'; //eslint-disable-line monorepo/no-internal-import

import { change } from 'redux-form';
import { getLocale, getHeadConfig } from '@ynap/config-state';

/* 
 * Keeping the same function name even though this action is now unselecting to avoid 
 * doing changes in all places where this is called, since it will soon suffer big 
 * changes or even be removed due to the new marketing consent options 
 */
export const selectMarketingConsentIfNeeded = (formName, field) => {
    return (dispatch, getState) => {
        const state = getState();
        const { country } = getLocale(state);
        const { flags } = getHeadConfig(state);
        const { disableAutomaticConsentCountryList } = flags || {}
        
        if (disableAutomaticConsentCountryList) {
            const geoCountry = getCookie('geoIP');
            if (geoCountry) {
                if (disableAutomaticConsentCountryList.includes(geoCountry) && disableAutomaticConsentCountryList.includes(country)) {
                    return dispatch(change(formName, field, 'false'));
                }
            }
        }
    };
};
